<template>
  <v-container fluid fill-height pa-0>
    <v-layout :column="$vuetify.breakpoint.xs" fill-height>
      <v-layout column justify-end fill-height>
        <div style="position:relative; flex-grow: 1; overflow:hidden; background-color: #2c204d;">
          <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; overflow:hidden;">
            <video id="remoteVideo" autoplay playsinline/>
          </div>
          <v-icon v-if="remoteStream === null" style="position: absolute; right: 50%; bottom: 50%; transform: translate(50%,50%); font-size: 35vw; opacity: 0.25;" color="white">account_circle</v-icon>
          <div style="position: absolute; bottom: 10px; left: 10px; width: 20%; height: 20%; ">
            <video id="localVideo" autoplay playsinline muted/>
            <canvas id="canvas" style="display: none;"/>
          </div>
        </div>
        <v-divider/>
        <v-toolbar :prominent="!$vuetify.breakpoint.xs" flat>
          <v-spacer/>
          <v-btn flat large color="success" v-on:click="pause" v-if="signedIn && (waitingForPeer || isChatReady)"><v-icon>pause</v-icon> Stop</v-btn>
          <v-btn flat large color="success" v-on:click="next" v-if="signedIn && !waitingForPeer && !isChatReady"><v-icon>play_arrow</v-icon> Start</v-btn>
          <v-btn flat large color="success" v-on:click="next" v-if="signedIn && !waitingForPeer && isChatReady"><v-icon>skip_next</v-icon> Next</v-btn>
          <v-spacer/>
        </v-toolbar>
        <!-- <v-layout row align-center justify-center style="flex-grow: 0;">
          <v-btn round large color="success" v-on:click="pause" v-if="signedIn && (waitingForPeer || isChatReady)"><v-icon>pause</v-icon> Stop</v-btn>
          <v-btn round large color="success" v-on:click="next" v-if="signedIn && !waitingForPeer && !isChatReady"><v-icon>play_arrow</v-icon> Start</v-btn>
          <v-btn round large color="success" v-on:click="next" v-if="signedIn && !waitingForPeer && isChatReady"><v-icon>skip_next</v-icon> Next</v-btn>
        </v-layout> -->
      </v-layout>
      <v-divider vertical v-if="!$vuetify.breakpoint.xs"/>
      <v-divider v-if="$vuetify.breakpoint.xs"/>
      <v-layout column justify-end fill-height>
        <div class="content-wrapper chat-background" style="flex-grow: 1;">
          <div id="chat-content-scroll" class="content-scroll" data-simplebar data-simplebar-auto-hide="false">
            <div>
              <v-layout row pl-4 pr-4 v-for="i in roomMessages" :key="`${i.messageId}`">
                <div class="remote-chat-message" v-if="i.userId !== userId">
                  {{ i.text }}
                </div>
                <v-spacer/>
                <div class="local-chat-message" v-if="i.userId === userId">
                  {{ i.text }}
                </div>
              </v-layout>
            </div>
          </div>
          <div v-if="signedIn && !waitingForPeer && !isChatReady" class="text-xs-center" style="position: absolute; right: 50%; bottom: 50%; transform: translate(50%,50%); opacity: 0.25;">
            <h2>Click START when you are ready</h2>
          </div>
          <div v-if="waitingForPeer" class="text-xs-center" style="position: absolute; right: 50%; bottom: 50%; transform: translate(50%,50%); opacity: 0.25;">
            <v-progress-circular indeterminate :size="70" :width="7" style="margin: 20px;" color="primary"/>
            <h2>Looking for someone you can chat with...</h2>
          </div>
        </div>
        <v-divider/>
        <v-toolbar id="chat-input-box" prominent flat>
          <v-text-field solo style="0px; position: absolute; top: 7px; left: 7px; right: 7px; bottom: 7px;" label="Message" v-model="input" append-icon="send" v-on:keyup.enter="submitInput()" @click:append="submitInput()" :disabled="!isChatReady"/>
        </v-toolbar>
        <!-- <v-layout row pl-3 pr-3 style="flex-grow: 0;">
          <v-flex id="chat-input-box" pt-3>
            <v-text-field solo light counter=150 label="Message" v-model="input" append-icon="send" v-on:keyup.enter="submitInput()" @click:append="submitInput()" :disabled="!isChatReady"/>
          </v-flex>
        </v-layout> -->
      </v-layout>
    </v-layout>
  </v-container>
</template>

<style>
video {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
#chat-input-box .v-input__slot {
    border-radius: 100px;
}
.chat-background {
  background-color: #eceff1;
}
.local-chat-message {
   word-wrap: break-word;
   max-width: 75%;
   background-color: white;
   border-radius: 20px;
   padding: 5px 10px;
   margin: 5px 0px;
   text-align: right
}
.remote-chat-message {
   word-wrap: break-word;
   max-width: 75%;
   background-color: #DB4437;
   color: white;
   border-radius: 20px;
   padding: 5px 10px;
   margin: 5px 0px;
   text-align: left
}
.fix-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
}
.content-wrapper {
  position: relative;
  width: 100%;
}
.content-scroll {
  position: absolute !important;
  top: 0; left: 0 !important;
  right: 0; bottom: 0 !important;
  display: flex !important;
  flex-direction: column-reverse !important;
}
/* .simplebar-track {
    width: 14px;
}
.simplebar-scrollbar {
    width: 10px;
}
.simplebar-scrollbar:before {
    background: white;
    border-radius: 10px;
} */
</style>

<script>
import { mapState, mapActions } from 'vuex'
import SimpleBar from 'simplebar'
export default {
  data () {
    return {
      input: '',
      chatScrollBar: null
    }
  },

  mounted: function () {
    this.chatScrollBar = new SimpleBar(document.getElementById('chat-content-scroll'), { autoHide: false })
  },

  watch: {
    'roomMessages': function (val, oldVal) {
      this.$nextTick(() => {
        this.chatScrollBar.getScrollElement().scrollTop = this.chatScrollBar.getScrollElement().scrollHeight
      })
    },
    'videoLocalStream': function (val, oldVal) {
      if (val && !oldVal) {
        setTimeout(() => this.captureSnapshot(), 1000)
      }
    }
  },

  computed: {
    roomMessages () {
      return this.$store.state.room.chat.messages
    },
    videoLocalStream () {
      return this.$store.state.room.video.localStream
    },
    videoRemoteStream () {
      return this.$store.state.room.video.remoteStream
    },
    ...mapState([
      'userId', 'signedIn'
    ]),
    ...mapState({
      roomId: state => state.room.roomId,
      waitingForPeer: state => state.waitingQueue.isWaiting,
      isChatReady: state => state.room.chat.isReady,
      remoteStream: state => state.room.video.remoteStream
    })
  },

  methods: {
    ...mapActions([
      'signUp', 'logout', 'next', 'pause'
    ]),
    ...mapActions(
      'room/chat', [ 'say' ]
    ),
    ...mapActions(
      'room/video', [ 'updateLocalSnapshot' ]
    ),
    submitInput () {
      if (this.input !== '' && this.input.length <= 150) {
        this.say({ text: this.input })
        this.input = ''
      }
    },
    captureSnapshot () {
      let video = document.getElementById('localVideo')
      let canvas = document.getElementById('canvas')
      let width = 320
      let height = width * video.videoHeight / video.videoWidth
      canvas.setAttribute('width', width)
      canvas.setAttribute('height', height)
      canvas.getContext('2d').drawImage(video, 0, 0, width, height)
      canvas.toBlob(blob => {
        this.updateLocalSnapshot({ blob: blob })
      },
      'image/jpeg', 0.75
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chat.vue